import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {ThemeProvider} from "./components/theme-context/theme-context";
import {AuthProvider} from "./components/auth-context/auth";
import {CustomAlertProvider} from "./components/custom-alert";
import "./components/translations/i18n"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
        <AuthProvider>
            <CustomAlertProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </CustomAlertProvider>
        </AuthProvider>
    </ThemeProvider>
);
